module.exports = __webpack_public_path__ + "static/media/icon-close--med-gray.47aa3136.svg";